import { useAccountContext } from 'components/contexts/AccountContext'
import { useConnectedUserContext } from 'components/contexts/ConnectedUserContext'

const useHasPartnerAccess = () => {
  const { partnerAccountKey } = useAccountContext()
  const iAm = useConnectedUserContext()

  const isPartnerUser = !!iAm?.products?.includes('PARTNER')
  const hasPartnerAccountAccess = !!iAm?.accounts?.find((account) => account.key === partnerAccountKey)

  return {
    isPartnerUser,
    hasPartnerAccountAccess,
    hasPartnerAccess: !!partnerAccountKey && isPartnerUser && hasPartnerAccountAccess,
  }
}

export default useHasPartnerAccess
